export default __webpack_public_path__ + "static/media/powered-by-jdp.5c6c777c.jpg";